/* riwi-cart-contents.js (.com) — Stepper, Entfernen, Gratis-Zugabe fuer snippets/riwi-cart-contents.liquid.
 * Port von riwi-us-lp/assets/riwi-cart-contents.js (HEAD 17cddf0), W2 riwi-com-pdp-port 24.09.2026.
 * Weggelassen ggue. .us: Cut-off-Countdown (America/Chicago), Legacy-Upsell-Swatches — auf .com
 * nicht im Markup. Neu: Fehlertexte kommen lokalisiert aus data-rc-msg-error (Locale-Key
 * riwi_cart.error_generic), Code-nur-anwenden-Knopf (data-rc-apply-code), HTML-Antworten
 * (Shopify-Bot-Schutz 429 "Verifying your connection…") gelten IMMER als Fehler, nie als leerer Cart.
 *
 * Regeln:
 * - Erfolg NIE per Timer. Jede Mutation wird an der Antwort gemessen und die Section neu gerendert.
 * - Client-Gate 0-€-Sperre BITGLEICH zum Liquid-Server-Gate:
 *     item.quantity > 0 && item.final_line_price === 0 && item.discounts.length === 0
 * - Rabattcodes NUR aus dem echten Warenkorb (GET cart.js) mergen, nie aus der add.js-Antwort
 *   (die fuehrt kein discount_codes -> update.js wuerde FREE12-XXL still loeschen, Lektion .us F4).
 *   Ist cart.js nicht lesbar: Discount-Schritt auslassen statt mit reduzierter Liste senden.
 * - Alle Routen ueber Shopify.routes.root (Sprachpfade /en/, /fr/ …).
 * - Ohne JS bleibt alles bedienbar (Update-Knopf, url_to_remove-Links, natives Formular).
 */
(function () {
  'use strict';

  var BUSY = 'is-busy';

  function root(el) { return el.closest('[data-riwi-cart]'); }
  function sectionId(box) { return box.getAttribute('data-rc-section-id') || ''; }
  function msgError(box) {
    return (box && box.getAttribute('data-rc-msg-error')) || '';
  }

  /* Client-Gate — Formulierung identisch zum Liquid-Server-Gate. */
  function isZeroBlocked(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (i) {
      return i.quantity > 0 && i.final_line_price === 0 && i.discounts.length === 0;
    });
  }

  function cartRoot() {
    var r = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function cartUrl(path) { return cartRoot() + String(path).replace(/^\/+/, ''); }
  /* W10 (25.09.2026): Vorschau-Variante /cart?view=riwi (templates/cart.riwi.json), solange
     templates/cart.json noch Dawn ist. Der view-Parameter der AKTUELLEN Seite wird an jede
     Cart-Seiten-Route gehaengt (Refetch, /discount/-Redirect), sonst faellt die Vorschau nach
     einer Aktion auf den Dawn-Warenkorb zurueck. Ohne ?view= (Normalfall/nach Freischaltung)
     sind die Routen unveraendert. */
  function viewParam() {
    var m = /[?&]view=([A-Za-z0-9_-]+)/.exec(String(window.location.search || ''));
    return m ? m[1] : '';
  }
  function cartPageUrl() {
    var v = viewParam();
    return cartUrl('cart') + (v ? '?view=' + v : '');
  }
  function discountRoute(code, redirectPath) {
    return cartUrl('discount/' + encodeURIComponent(code)) + '?redirect=' + encodeURIComponent(redirectPath || cartPageUrl());
  }

  /* JSON nur, wenn die Antwort wirklich JSON ist. Bot-Schutz liefert 429 + text/html.
     W7/B2 (24.09.2026, gemessen auf Staging): /cart/change.js und /cart.js antworten mit
     "text/javascript; charset=utf-8" (JSON-Body) - trotz Accept: application/json. Die alte
     Pruefung auf "json" verwarf damit JEDE erfolgreiche Mengen-/Entfernen-Antwort als Fehler:
     die Aenderung war im Warenkorb, die Seite zeigte "Das hat nicht geklappt" und das alte
     Markup (Gate-1-Befund: "+" auf der Gratis-Zeile -> Vollpreis-Duplikat + Fehlermeldung).
     Abgelehnt wird deshalb nur, was sicher KEIN JSON ist (text/html = Bot-Schutz/Fehlerseite). */
  function isJson(res) {
    var ct = ((res.headers && res.headers.get && res.headers.get('content-type')) || '').toLowerCase();
    return ct.indexOf('json') !== -1 || ct.indexOf('javascript') !== -1;
  }
  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!isJson(res)) return { ok: false, status: res.status, data: null, html: true };
      return res.json().then(
        function (data) { return { ok: res.ok, status: res.status, data: data }; },
        function () { return { ok: false, status: res.status, data: null }; }
      );
    });
  }

  function refreshFrom(box, html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('[data-riwi-cart]');
    if (!next) return false;
    next.classList.remove('no-js');
    var codeKeep = codePanelState(box);
    var focusRow = box.getAttribute('data-rc-focus-row');
    box.replaceWith(next);
    restoreCodePanels(next, codeKeep);
    if (focusRow !== null) focusAfterRemove(next, Number(focusRow));
    document.dispatchEvent(new CustomEvent('riwi-cart:updated', { detail: { container: next }, bubbles: true }));
    return true;
  }

  function setError(box, id, message) {
    var target = box.querySelector('#' + id);
    if (target) target.textContent = message || '';
  }

  /* Mengen-/Entfernen-Mutation ueber change.js mit Section-Rendering im selben Request. */
  function mutate(box, body) {
    var sid = sectionId(box);
    if (sid) body.sections = sid;
    box.setAttribute('aria-busy', 'true');
    return postJson(cartUrl('cart/change.js'), body).then(function (out) {
      box.removeAttribute('aria-busy');
      if (!out.ok) {
        /* 422 liefert eine Shopify-Beschreibung (z. B. Bestand) — die ist schon lokalisiert. */
        var why = out.data && (out.data.description || out.data.message);
        return { error: (typeof why === 'string' && why) || msgError(box) };
      }
      var sections = out.data.sections || {};
      var html = sid ? sections[sid] : null;
      if (html && refreshFrom(box, html)) return { ok: true, cart: out.data };
      window.location.reload();
      return { ok: true, reloaded: true };
    }, function () {
      box.removeAttribute('aria-busy');
      return { error: msgError(box) };
    });
  }

  /* Codes aus dem ECHTEN Warenkorb. Auf PDP/LP2 haelt riwi-lp2.js dieselbe Funktion
     (window.RiwiLp2Cart.currentCodes) — dann wird die benutzt (eine Implementierung). */
  function currentCodes() {
    var lp2 = window.RiwiLp2Cart;
    if (lp2 && typeof lp2.currentCodes === 'function') return lp2.currentCodes();
    return fetch(cartUrl('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok || !isJson(res)) return { ok: false, status: res.status, codes: [], cart: null };
        return res.json().then(function (cart) {
          var list = cart && cart.discount_codes;
          if (Object.prototype.toString.call(list) !== '[object Array]') {
            return { ok: false, status: res.status, codes: [], cart: cart || null };
          }
          return { ok: true, status: res.status, codes: list, cart: cart };
        }, function () { return { ok: false, status: res.status, codes: [], cart: null }; });
      }, function () { return { ok: false, status: 0, codes: [], cart: null }; });
  }

  function mergeCodes(existing, adds) {
    var out = [], seen = {};
    (existing || []).forEach(function (e) {
      var c = (e && e.code ? String(e.code) : '').trim();
      if (c && !seen[c.toUpperCase()]) { seen[c.toUpperCase()] = 1; out.push(c); }
    });
    (adds || []).forEach(function (c) {
      c = (c || '').trim();
      if (c && !seen[c.toUpperCase()]) { seen[c.toUpperCase()] = 1; out.push(c); }
    });
    return out.join(',');
  }

  function findDiscountEntry(cart, code) {
    var list = cart && cart.discount_codes;
    if (!list || !list.length || !code) return null;
    var want = String(code).toUpperCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].code || '').toUpperCase() === want) return list[i];
    }
    return null;
  }

  /* Section neu holen. Drawer: ueber den Drawer-Controller (Refetch gegen die AKTUELLE Seite,
     nie gegen /cart — Guard template.name). Seite: GET cart?section_id=… */
  function refetchSection(box) {
    if (box.getAttribute('data-rc-context') === 'drawer'
        && window.RiwiCartDrawer && typeof window.RiwiCartDrawer.refresh === 'function') {
      return Promise.resolve(window.RiwiCartDrawer.refresh());
    }
    var sid = sectionId(box);
    if (!sid) { window.location.reload(); return Promise.resolve(); }
    var v = viewParam();
    return fetch(cartUrl('cart') + '?section_id=' + encodeURIComponent(sid) + (v ? '&view=' + v : ''), { headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('http-' + res.status);
        return res.text();
      })
      .then(function (html) { if (!refreshFrom(box, html)) window.location.reload(); })
      ['catch'](function () { window.location.reload(); });
  }

  /* Codes auf den bestehenden Stand mergen und setzen. Liefert {ok, applied}. */
  function applyCodes(codes) {
    return currentCodes().then(function (state) {
      if (!state.ok) {
        console.warn('[riwi-cart] cart.js nicht lesbar (Status ' + state.status + ') - Codes werden NICHT gesetzt.', codes);
        return { ok: false, upd: null };
      }
      return postJson(cartUrl('cart/update.js'), { discount: mergeCodes(state.codes, codes) })
        .then(function (upd) { return { ok: upd.ok, upd: upd }; });
    });
  }

  /* opts: { items: [{id, quantity}], codes: [string], dropIfCodeFails: [{id, code}], onError } */
  function addAndApply(box, opts) {
    var items = (opts && opts.items) || [];
    var codes = ((opts && opts.codes) || []).filter(Boolean);
    var drop = (opts && opts.dropIfCodeFails) || [];
    var onError = (opts && opts.onError) || function () {};
    if (!items.length || typeof fetch !== 'function') { onError(msgError(box)); return Promise.resolve(); }

    return postJson(cartUrl('cart/add.js'), { items: items }).then(function (add) {
      if (!add.ok) {
        var why = add.data && (add.data.description || add.data.message);
        onError((typeof why === 'string' && why) || msgError(box));
        return;
      }
      if (!codes.length) return refetchSection(box);
      return applyCodes(codes).then(function (res) {
        if (!res.upd) return refetchSection(box); /* Zustand unbekannt: nichts weiter mutieren */
        var upd = res.upd;
        var removals = [];
        drop.forEach(function (d) {
          if (!d || !d.code || !d.id) return;
          var entry = upd.ok ? findDiscountEntry(upd.data, d.code) : null;
          if (entry && entry.applicable === true) return;
          /* Gratis-Position nur entfernen, wenn update.js den Code WIRKLICH als nicht anwendbar
             gemeldet hat — bei unbekanntem Zustand (HTML/429) nichts loeschen. */
          if (!upd.ok) return;
          var keep = 0;
          items.forEach(function (it) { if (String(it.id) === String(d.id)) keep += (it.quantity || 1); });
          keep -= 1;
          if (keep < 0) keep = 0;
          removals.push(postJson(cartUrl('cart/change.js'), { id: String(d.id), quantity: keep })['catch'](function () {}));
        });
        return (removals.length ? Promise.all(removals) : Promise.resolve()).then(function () {
          var primary = codes[0];
          var entry = upd.ok ? findDiscountEntry(upd.data, primary) : null;
          if (entry && entry.applicable === true) return refetchSection(box);
          if (!upd.ok) return refetchSection(box);
          /* Leitcode nicht anwendbar: /discount/-Route als Fallback (Cookie, erst im Checkout sichtbar). */
          window.location.href = discountRoute(primary, cartPageUrl());
        });
      });
    }, function () { onError(msgError(box)); });
  }

  function lineOf(el) { return el.closest('[data-rc-line]'); }

  /* Auch die Gratiszeile (FREE12-12er) hat den normalen Stepper (Owner 28.09.2026): Mehrmenge
     berechnet Shopify zum Originalpreis, der Rabatt deckt weiter genau eine Einheit. */
  function changeLine(line, quantity) {
    var box = root(line);
    if (!box) return;
    var index = line.getAttribute('data-rc-index');
    var ctx = box.getAttribute('data-rc-context') || 'page';
    var errId = 'RiwiCartError-' + ctx + '-' + index;
    setError(box, errId, '');
    line.classList.add(BUSY);
    mutate(box, { line: Number(index), quantity: quantity }).then(function (out) {
      line.classList.remove(BUSY);
      if (out && out.error) {
        var still = document.querySelector('[data-riwi-cart][data-rc-context="' + ctx + '"]');
        if (still) setError(still, errId, out.error);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-rc-step]');
    if (step && !step.disabled) {
      var line = lineOf(step);
      if (!line) return;
      var input = line.querySelector('input[data-rc-qty-input]');
      var current = Number(input && input.value) || Number(line.getAttribute('data-rc-qty')) || 0;
      var next = current + Number(step.getAttribute('data-rc-step'));
      if (next < 0) next = 0;
      event.preventDefault();
      changeLine(line, next);
      return;
    }
    var remove = event.target.closest('[data-rc-remove]');
    if (remove) {
      var rline = lineOf(remove);
      if (!rline) return;
      event.preventDefault();
      changeLine(rline, 0);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('input[data-rc-qty-input]');
    if (!input) return;
    var line = lineOf(input);
    if (!line) return;
    var value = Number(input.value);
    if (!Number.isFinite(value) || value < 0) value = 0;
    changeLine(line, value);
  });

  /* Gratis-Zugabe: EIN Artikel + zugehoeriger Code; greift der Code nicht, fliegt die
     Position wieder raus (nie eine Gratis-Zusage kassieren, die der Warenkorb nicht gewaehrt). */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('button[data-rc-add-gift]');
    if (!btn || btn.disabled) return;
    var box = root(btn);
    if (!box) return;
    var wrap = btn.closest('.riwi-cart__gift');
    var errorEl = wrap ? wrap.querySelector('[data-rc-gift-error]') : null;
    var variantId = parseInt(btn.getAttribute('data-rc-gift-variant'), 10) || 0;
    var code = (btn.getAttribute('data-rc-gift-code') || '').trim();
    if (!variantId || !code) return;
    event.preventDefault();
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.textContent = '';
    addAndApply(box, {
      items: [{ id: variantId, quantity: 1 }],
      codes: [code],
      dropIfCodeFails: [{ id: variantId, code: code }],
      onError: function (msg) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (errorEl) errorEl.textContent = msg;
      }
    });
  });

  /* Nur Code anwenden (12er liegt schon drin, zu vollem Preis). */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('button[data-rc-apply-code]');
    if (!btn || btn.disabled) return;
    var box = root(btn);
    if (!box) return;
    var code = (btn.getAttribute('data-rc-apply-code') || '').trim();
    if (!code) return;
    event.preventDefault();
    var wrap = btn.closest('.riwi-cart__gift');
    var errorEl = wrap ? wrap.querySelector('[data-rc-gift-error]') : null;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.textContent = '';
    applyCodes([code]).then(function (res) {
      var entry = res.upd && res.upd.ok ? findDiscountEntry(res.upd.data, code) : null;
      if (entry && entry.applicable === true) return refetchSection(box);
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (errorEl) errorEl.textContent = msgError(box);
    }, function () {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (errorEl) errorEl.textContent = msgError(box);
    });
  });

  /* ---- Rabattcode-Feld (snippets/riwi-cart-discounts.liquid, code_field) --------------------
     Ablauf Anwenden:
       1. bestehende Codes aus cart.js (nie aus einer add.js-Antwort); nicht lesbar -> Fehler,
          nichts senden (sonst wuerde update.js die Liste ERSETZEN und FREE12-XXL loeschen)
       2. update.js {discount: "BESTEHEND,NEU"}
       3. neuer Code applicable -> Section neu rendern
          neuer Code nicht applicable ODER ein vorher greifender Code greift nicht mehr
          (Kombinations-Konflikt) -> alte Liste zuruecksetzen + Hinweis "ungueltig"
       4. 429 / HTML (Bot-Schutz) / Netzfehler -> allgemeine Fehlermeldung, kein Rueckbau
          auf Verdacht (Zustand unbekannt). */
  function codeUi(box) {
    var wrap = box && box.querySelector('[data-rc-code-form]');
    if (!wrap) return null;
    return {
      wrap: wrap,
      input: wrap.querySelector('input[data-rc-code-input]'),
      btn: wrap.querySelector('button[data-rc-code-apply]'),
      msg: wrap.querySelector('[data-rc-code-msg]')
    };
  }
  function codeMsg(ui, text, isError) {
    if (!ui || !ui.msg) return;
    ui.msg.textContent = text || '';
    ui.msg.classList.toggle('is-error', !!(text && isError));
    if (ui.input) {
      if (text && isError) ui.input.setAttribute('aria-invalid', 'true');
      else ui.input.removeAttribute('aria-invalid');
    }
  }
  function codeBusy(ui, on) {
    if (!ui) return;
    if (ui.btn) {
      ui.btn.disabled = !!on;
      if (on) ui.btn.setAttribute('aria-busy', 'true'); else ui.btn.removeAttribute('aria-busy');
    }
    ui.wrap.classList.toggle(BUSY, !!on);
  }
  function codeList(entries) {
    return (entries || []).map(function (e) { return e && e.code ? String(e.code).trim() : ''; }).filter(Boolean);
  }
  function applicableCodes(cart) {
    return ((cart && cart.discount_codes) || []).filter(function (e) { return e && e.applicable === true; })
      .map(function (e) { return String(e.code).toUpperCase(); });
  }
  /* Setzt die Codeliste exakt (leer = alle Codes entfernen). */
  function setCodes(list) {
    return postJson(cartUrl('cart/update.js'), { discount: (list || []).join(',') });
  }

  function applyCodeFromField(box) {
    var ui = codeUi(box);
    if (!ui || !ui.input || (ui.btn && ui.btn.disabled)) return;
    var code = String(ui.input.value || '').trim();
    if (!code) { ui.input.focus(); return; }
    var invalid = (ui.msg && ui.msg.getAttribute('data-rc-msg-invalid')) || msgError(box);
    codeMsg(ui, '', false);
    codeBusy(ui, true);
    function fail(text, isInvalid) {
      codeBusy(ui, false);
      openCodePanel(ui);
      codeMsg(ui, text, true);
      if (isInvalid && ui.input) { ui.input.focus(); ui.input.select(); }
    }
    currentCodes().then(function (state) {
      if (!state.ok) { fail(msgError(box)); return; }
      var before = codeList(state.codes);
      var beforeOk = applicableCodes(state.cart);
      var already = before.some(function (c) { return c.toUpperCase() === code.toUpperCase(); });
      if (already && beforeOk.indexOf(code.toUpperCase()) !== -1) {
        ui.input.value = '';
        ui.wrap.setAttribute('data-rc-code-close', '');
        return refetchSection(box);
      }
      return postJson(cartUrl('cart/update.js'), { discount: mergeCodes(state.codes, [code]) }).then(function (upd) {
        if (!upd.ok || !upd.data) { fail(msgError(box)); return; }
        var entry = findDiscountEntry(upd.data, code);
        var nowOk = applicableCodes(upd.data);
        var lost = beforeOk.filter(function (c) { return nowOk.indexOf(c) === -1; });
        if (entry && entry.applicable === true && !lost.length) {
          ui.input.value = '';
          ui.wrap.setAttribute('data-rc-code-close', '');
          return refetchSection(box);
        }
        /* Nur den neuen Code wieder herausnehmen, die vorherige Liste bleibt unveraendert. */
        var restore = before.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
        return setCodes(restore).then(function (back) {
          if (!back.ok) console.warn('[riwi-cart] Rueckbau der Codeliste fehlgeschlagen (Status ' + back.status + ').');
          fail(invalid, true);
        }, function () { fail(invalid, true); });
      }, function () { fail(msgError(box)); });
    }, function () { fail(msgError(box)); });
  }

  function removeCode(btn) {
    var box = root(btn);
    if (!box || btn.disabled) return;
    var code = String(btn.getAttribute('data-rc-remove-code') || '').trim();
    if (!code) return;
    var ui = codeUi(box);
    btn.disabled = true;
    codeMsg(ui, '', false);
    function fail() { btn.disabled = false; openCodePanel(ui); codeMsg(ui, msgError(box), true); }
    currentCodes().then(function (state) {
      if (!state.ok) { fail(); return; }
      var rest = codeList(state.codes).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
      return setCodes(rest).then(function (upd) {
        if (!upd.ok) { fail(); return; }
        box.setAttribute('data-rc-focus-row', String(Array.prototype.indexOf.call(box.querySelectorAll('button[data-rc-remove-code]'), btn)));
        return refetchSection(box);
      }, fail);
    }, fail);
  }

  document.addEventListener('click', function (event) {
    var apply = event.target.closest('button[data-rc-code-apply]');
    if (apply) {
      var box = root(apply);
      if (!box) return;
      event.preventDefault();
      applyCodeFromField(box);
      return;
    }
    var rm = event.target.closest('button[data-rc-remove-code]');
    if (rm) {
      event.preventDefault();
      removeCode(rm);
    }
  });
  /* Enter im Feld = Anwenden (nicht das Cart-Formular absenden). */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.isComposing) return;
    var input = event.target.closest && event.target.closest('input[data-rc-code-input]');
    if (!input) return;
    event.preventDefault();
    var box = root(input);
    if (box) applyCodeFromField(box);
  });
  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('input[data-rc-code-input]');
    if (!input) return;
    var box = root(input);
    var ui = box && codeUi(box);
    if (ui && ui.msg && ui.msg.textContent) codeMsg(ui, '', false);
  });

  /* Eingeklapptes Code-Feld: [data-rc-code-toggle] (aria-expanded/aria-controls) klappt das
     Panel [data-rc-code-form] auf und zu. Das Panel kommt mit hidden vom Server; ohne JS macht
     eine noscript-Regel es sichtbar. Offen-Zustand, Eingabe, Meldung und Fokus ueberstehen jeden
     Section-Swap (refreshFrom). Nach erfolgreichem Anwenden (data-rc-code-close) bleibt es zu,
     der Code steht dann als eigene Zeile da. */
  function codeUiOf(wrap) {
    return {
      wrap: wrap,
      input: wrap.querySelector('input[data-rc-code-input]'),
      btn: wrap.querySelector('button[data-rc-code-apply]'),
      msg: wrap.querySelector('[data-rc-code-msg]')
    };
  }
  function codePanelById(box, id) {
    var hit = null;
    if (!box || !id) return hit;
    box.querySelectorAll('[data-rc-code-form][id]').forEach(function (w) { if (!hit && w.id === id) hit = w; });
    return hit;
  }
  function codeToggleFor(wrap) {
    var box = wrap && root(wrap);
    var hit = null;
    if (!box || !wrap.id) return hit;
    box.querySelectorAll('[data-rc-code-toggle]').forEach(function (t) {
      if (!hit && t.getAttribute('aria-controls') === wrap.id) hit = t;
    });
    return hit;
  }
  function setCodeOpen(wrap, open, animate) {
    if (!wrap) return;
    wrap.hidden = !open;
    var t = codeToggleFor(wrap);
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    wrap.classList.remove('is-opening');
    if (open && animate) { void wrap.offsetWidth; wrap.classList.add('is-opening'); }
  }
  function openCodePanel(ui) {
    if (ui && ui.wrap && ui.wrap.hidden) setCodeOpen(ui.wrap, true, false);
  }
  /* Nach dem Entfernen eines Codes: Fokus auf die naechste verbleibende x-Schaltflaeche, sonst auf den Link. */
  function focusAfterRemove(next, index) {
    var rows = next.querySelectorAll('button[data-rc-remove-code]');
    var target = rows.length ? rows[Math.min(Math.max(index, 0), rows.length - 1)] : next.querySelector('[data-rc-code-toggle]');
    if (!target) return;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }
  function codePanelState(box) {
    var out = [];
    if (!box) return out;
    box.querySelectorAll('[data-rc-code-form][id]').forEach(function (wrap) {
      if (wrap.hidden) return;
      if (wrap.hasAttribute('data-rc-code-close')) {
        /* Erfolg: Panel bleibt zu, der Fokus geht an den Link (das Feld verschwindet). */
        var a = document.activeElement;
        out.push({ id: wrap.id, closed: true, focus: !a || a === document.body || wrap.contains(a) });
        return;
      }
      var ui = codeUiOf(wrap);
      out.push({
        id: wrap.id,
        value: ui.input ? ui.input.value : '',
        msg: ui.msg ? ui.msg.textContent : '',
        err: !!(ui.msg && ui.msg.classList.contains('is-error')),
        focus: !!(ui.input && document.activeElement === ui.input)
      });
    });
    return out;
  }
  function restoreCodePanels(next, list) {
    (list || []).forEach(function (s) {
      var wrap = codePanelById(next, s.id);
      if (!wrap) return;
      if (s.closed) {
        var t = codeToggleFor(wrap);
        if (t && s.focus) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
        return;
      }
      setCodeOpen(wrap, true, false);
      var ui = codeUiOf(wrap);
      if (ui.input && s.value) ui.input.value = s.value;
      if (s.msg) codeMsg(ui, s.msg, s.err);
      if (s.focus && ui.input) {
        try { ui.input.focus({ preventScroll: true }); } catch (e) { ui.input.focus(); }
      }
    });
  }
  document.addEventListener('click', function (event) {
    var t = event.target.closest && event.target.closest('button[data-rc-code-toggle]');
    if (!t) return;
    var wrap = codePanelById(root(t), t.getAttribute('aria-controls'));
    if (!wrap) return;
    event.preventDefault();
    var open = wrap.hidden;
    setCodeOpen(wrap, open, true);
    if (open) {
      var input = wrap.querySelector('input[data-rc-code-input]');
      if (input) input.focus();
    }
  });
  document.addEventListener('keydown', function (event) {
    if ((event.key !== 'Escape' && event.key !== 'Esc') || event.isComposing) return;
    var wrap = event.target.closest && event.target.closest('[data-rc-code-form]');
    if (!wrap || wrap.hidden) return;
    var t = codeToggleFor(wrap);
    if (!t) return;
    event.preventDefault();
    setCodeOpen(wrap, false, false);
    t.focus();
  });

  /* Lieferdatum-Spanne (data-edd) aus snippets/riwi-atc-trust.liquid, falls dort gerendert.
     ZWEITE Implementierung derselben Rechnung wie in assets/riwi-lp2.js (Sa/So uebersprungen) —
     beide im selben Commit aendern. Datumsformat in der Seitensprache (.com: de/en/es/fr/it/nl/pl). */
  function eddAdd(d, n) {
    var x = new Date(d.getTime()), c = 0;
    while (c < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) c++; }
    return x;
  }
  function eddFmt(d, lang) {
    try { return d.toLocaleDateString(lang || 'de', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { return d.toDateString(); }
  }
  function initEdd(box) {
    var lang = box.getAttribute('data-rc-locale') || document.documentElement.lang || 'de';
    box.querySelectorAll('[data-edd]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-edd-min'), 10);
      var max = parseInt(el.getAttribute('data-edd-max'), 10);
      if (!(min > 0) || !(max >= min)) return;
      var now = new Date();
      el.textContent = eddFmt(eddAdd(now, min), lang) + ' – ' + eddFmt(eddAdd(now, max), lang);
    });
  }

  /* Zubehoer-Modul (riwi-lp2-addons.js, Paket W1) erst nachladen, wenn der Upsell-Block im DOM
     steht: ein per DOMParser+replaceWith eingehaengtes <script src> fuehrt der Browser nicht aus. */
  var addonsScriptState = null;
  function ensureAddonsScript() {
    if (addonsScriptState) return;
    if (window.RiwiLp2AddonsCore) { addonsScriptState = 'done'; return; }
    var scope = document.querySelector('[data-rc-addons-scope][data-rc-addons-src]');
    if (!scope) return;
    var src = (scope.getAttribute('data-rc-addons-src') || '').trim();
    if (!src) return;
    addonsScriptState = 'pending';
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.addEventListener('load', function () {
      addonsScriptState = 'done';
      if (window.RiwiLp2AddonsCore && window.RiwiLp2AddonsCore.mountCartBlocks) window.RiwiLp2AddonsCore.mountCartBlocks();
    });
    s.addEventListener('error', function () {
      addonsScriptState = null;
      console.error('[riwi-cart] Zubehoer-Modul konnte nicht geladen werden:', src);
    });
    document.head.appendChild(s);
  }

  /* ---- W28 (Owner-GO 30.09.2026): Sticky-Checkout-Leiste MOBIL, nur /cart --------------------
     Vorbild 1:1 die PDP-Sticky-ATC (assets/riwi-lp2.js, Zeilen ~777-1049): derselbe
     IntersectionObserver-Mechanismus, dieselbe CSS-Var --riwi-lp2-bottom-offset fuer die
     Chat-Launcher/Trusted-Shops-Anhebung (EINE Widget-Ebene, Lektion 29.09.2026 — nie zwei
     Anhebungs-Mechanismen gegeneinander).
     Anders als die PDP-Leiste (die auf jeder Breite laeuft) ist diese Leiste NUR mobil aktiv
     (CSS: display:none ausserhalb max-width:749px) — deshalb zusaetzlich ein Breiten-Gate hier,
     sonst wuerde ein am Desktop unsichtbares Element trotzdem die Chat-Anhebung ausloesen.
     Trigger (Brief 30.09.2026, bewusst EINFACHER als die PDP-Hysterese): sichtbar, solange der
     Haupt-Checkout-Button NICHT im Viewport ist (egal ob darueber oder darunter) — aus, sobald
     er zu mindestens 1px sichtbar ist. Die aus der Lektion bekannte Zweideutigkeit von
     isIntersecting=false (ueberscrollt vs. noch nie erreicht) ist hier unschaedlich, weil BEIDE
     Faelle dasselbe Ergebnis (Leiste an) verlangen.
     Der beobachtete Haupt-Button [data-rc-checkout] steht im normalen Fluss und wird durch
     unsere position:fixed-Leiste selbst nicht bewegt (kein Rueckkopplungs-Trigger, Lektion).

     Bei jedem Cart-Refresh (refreshFrom() oben, box.replaceWith) entsteht [data-riwi-cart] NEU:
     die alte Leiste, der alte Portal-Knoten in <body> und der alte Observer haengen dann an
     einem aus dem Dokument entfernten Baum. refreshStickyCheckout() baut deshalb bei JEDEM
     Aufruf zuerst restlos ab (Observer trennen, Ticker/Timer loeschen, alten Portal-Knoten aus
     <body> entfernen), bevor es — falls die neue Antwort ueberhaupt eine Leiste enthaelt
     (rc_ctx=='page' UND Warenkorb nicht leer) — neu aufbaut. So kann es nie zwei Leisten oder
     einen doppelt gebundenen Observer geben. */
  var stickyObserver = null;
  var stickyResizeHandler = null;
  var stickyTicker = null;
  var stickyHideTimer = null;
  var stickyPortal = null;
  var stickyMutationObserver = null;
  var stickyClickHandler = null;

  var STICKY_MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var STICKY_CHAT_OFFSET_VAR = '--riwi-lp2-bottom-offset';
  var STICKY_CHAT_SEL = '#riwi-chat-launcher, #fc_frame, .fc-widget-small, .fc-widget-normal,'
                       + ' [id^="minimized-trustbadge"], [id^="trustbadge-container"]';

  function stickyIsMobile() { return !!(STICKY_MQ && STICKY_MQ.matches); }

  /* Gate-2-BLOCKER (30.09.2026, docs/orchestration/reports/gate2-com-cart-w28-minibag.md):
     ein 3rd-Party-Widget (scDiscount__container / [id^="scDiscountApp"], Shipping-Bar +
     Rabattcode-Feld) injiziert sich clientseitig vor JEDEN Button mit name="checkout" im
     Cart-Formular. Der Sticky-Button traegt seit dem Fix kein form-/name-Attribut mehr, ist
     also ausserhalb der Selektor-Reichweite des Widgets — dieser Aufraeumer bleibt trotzdem als
     zweite Absicherung stehen (Widget-Selektoren koennten sich aendern, oder etwas anderes
     matcht kuenftig "checkout"-nahe Buttons). Nur Kind-Knoten der Leiste selbst entfernen, NIE
     ihre eigenen zwei Elemente. */
  function stripForeignStickyNodes(bar) {
    Array.prototype.slice.call(bar.children).forEach(function (child) {
      var isOwn = child.classList.contains('riwi-cart__sticky-checkout-meta')
        || child.hasAttribute('data-rc-sticky-btn');
      if (!isOwn) child.remove();
    });
  }

  function setStickyChatOffset(px) {
    var val = px > 0 ? Math.round(px) + 'px' : '0px';
    document.documentElement.style.setProperty(STICKY_CHAT_OFFSET_VAR, val);
    var t = px > 0 ? 'translateY(calc(-1 * ' + val + '))' : 'none';
    document.querySelectorAll(STICKY_CHAT_SEL).forEach(function (el) {
      el.style.setProperty('transform', t, 'important');
    });
  }

  function teardownStickyCheckout() {
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    if (stickyResizeHandler) {
      window.removeEventListener('resize', stickyResizeHandler);
      window.removeEventListener('orientationchange', stickyResizeHandler);
      stickyResizeHandler = null;
    }
    if (stickyTicker) { clearInterval(stickyTicker); stickyTicker = null; }
    if (stickyHideTimer) { clearTimeout(stickyHideTimer); stickyHideTimer = null; }
    if (stickyMutationObserver) { stickyMutationObserver.disconnect(); stickyMutationObserver = null; }
    if (stickyPortal && stickyPortal.parentNode) stickyPortal.parentNode.removeChild(stickyPortal);
    stickyPortal = null;
    stickyClickHandler = null; /* gehoert zum alten Button-Knoten, der mit dem Portal verschwindet */
    setStickyChatOffset(0);
  }

  function refreshStickyCheckout() {
    teardownStickyCheckout();

    var bar = document.querySelector('[data-rc-sticky-checkout]');
    if (!bar) return; /* Drawer-Refresh oder Warenkorb leer: Snippet rendert dann keine Leiste. */
    var box = root(bar);
    var mainBtn = box && box.querySelector('[data-rc-checkout]');
    if (!mainBtn) return;

    /* Portal an <body> — wie die PDP-Sticky-ATC (assets/riwi-lp2.js): innerhalb der Karte
       koennte ein transform an einem Vorfahren position:fixed an eine Spalte statt an den
       Viewport binden. Der Sticky-Button hat kein form-Attribut mehr (Gate-2-Fix unten) — er
       braucht dokumentweite Erreichbarkeit von mainBtn, nicht von einem Formular. */
    var portal = document.createElement('div');
    portal.className = 'riwi-cart-sticky-portal';
    document.body.appendChild(portal);
    portal.appendChild(bar);
    stickyPortal = portal;

    /* Gate-2-BLOCKER-Fix: sofort nach dem Umhaengen aufraeumen (falls das Widget schon beim
       Erst-Render mitgekommen ist) und per MutationObserver dauerhaft absichern — das Widget
       laedt teils zeitversetzt nach (bekanntes Verhalten, s. Chat/TS-Ticker oben). */
    stripForeignStickyNodes(bar);
    stickyMutationObserver = new MutationObserver(function () { stripForeignStickyNodes(bar); });
    stickyMutationObserver.observe(bar, { childList: true });

    /* Kein natives Submit mehr (kein form-/name-Attribut): ein echter Klick auf das Original-
       Element [data-rc-checkout] spiegelt exakt denselben Kaufweg — inkl. aller darauf
       haengenden App-Listener (z. B. Klarna) und des nativen disabled-Zustands bei 0-€-Sperre
       (rc_zero_block steht server-seitig an BEIDEN Buttons, s. Snippet). mainBtn.disabled prueft
       das defensiv zusaetzlich, falls sich der Zustand je asynchron unterscheiden sollte. */
    var stickyBtn = bar.querySelector('[data-rc-sticky-btn]');
    if (stickyBtn) {
      stickyClickHandler = function () { if (!mainBtn.disabled) mainBtn.click(); };
      stickyBtn.addEventListener('click', stickyClickHandler);
    }

    var shown = false;
    var mainVisible = true; /* sicherer Default vor dem ersten Observer-Callback: keine Leiste aufblitzen lassen */
    var HIDE_MS = 320;      /* etwas mehr als die 250-ms-CSS-Transition */

    function show() {
      if (shown) return;
      shown = true;
      if (stickyHideTimer) { clearTimeout(stickyHideTimer); stickyHideTimer = null; }
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      void bar.offsetHeight; /* Reflow: sonst fehlt der Startwert der Transition */
      bar.classList.add('is-visible');
      setStickyChatOffset(bar.getBoundingClientRect().height + 8);
    }

    function hide() {
      setStickyChatOffset(0);
      if (!shown) return;
      shown = false;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      if (stickyHideTimer) clearTimeout(stickyHideTimer);
      /* hidden erst NACH der Transition: sonst wuerde sie sofort abgeschnitten. */
      stickyHideTimer = window.setTimeout(function () {
        stickyHideTimer = null;
        if (!shown) bar.hidden = true;
      }, HIDE_MS);
    }

    function evaluate() {
      if (!stickyIsMobile()) { hide(); return; }
      if (mainVisible) hide(); else show();
    }

    if ('IntersectionObserver' in window) {
      stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { mainVisible = e.isIntersecting; });
        evaluate();
      }, { threshold: 0 });
      stickyObserver.observe(mainBtn);
    } else {
      mainVisible = false; /* kein IO: lieber dauerhaft sichtbar als nie (Rueckfallverhalten wie PDP). */
      evaluate();
    }

    stickyResizeHandler = function () { evaluate(); };
    window.addEventListener('resize', stickyResizeHandler, { passive: true });
    window.addEventListener('orientationchange', stickyResizeHandler, { passive: true });

    /* Spaet injizierte Widgets (Freshchat oft erst nach 6+ s): 30x1s nachziehen, wie die
       PDP-Leiste es tut — MutationObserver haette vor der Injektion nichts zu beobachten. */
    var tries = 0;
    stickyTicker = window.setInterval(function () {
      tries++;
      setStickyChatOffset(shown ? bar.getBoundingClientRect().height + 8 : 0);
      if (tries >= 30) { clearInterval(stickyTicker); stickyTicker = null; }
    }, 1000);
  }

  /* ---- W31 (Owner 30.09.2026): Rueckgabe-Popup ------------------------------------------
     Inhalt = shop.refund_policy (snippets/riwi-cart-returns-modal.liquid), Trigger direkt
     unter der Rueckgabe-Zeile (snippets/riwi-cart-contents.liquid).

     Portal EINMAL, nie doppelt: bei jedem Cart-Refresh (refreshFrom() oben, box.replaceWith)
     kommt eine FRISCHE Kopie des Dialogs im neuen [data-riwi-cart]-Markup mit (dasselbe
     Snippet wird bei jedem Server-Render erneut eingebunden). refreshReturnsModal() haengt die
     ERSTE Kopie per Portal an <body> (Grund wie beim Sticky-Button: position:fixed bindet in
     einem transformierten Vorfahren an dessen Box statt an den Viewport) und WIRFT jede
     weitere Kopie, die bei einem spaeteren Refresh noch innerhalb eines [data-riwi-cart]-Blocks
     auftaucht, einfach weg -- der Inhalt ist statisch (Rechtstext), es gibt nichts, das eine
     zweite Instanz rechtfertigt.

     Oeffnen/Schliessen laeuft NICHT ueber einen an den Trigger gebundenen Listener (der Trigger
     ist Teil von riwi-cart-contents.liquid und verschwindet bei jedem Refresh mit dem alten
     Knoten) -- sondern per Event-Delegation auf <document>, einmalig beim Laden dieses Scripts
     gebunden. Das ueberlebt jeden Refresh von selbst. */
  var returnsPortal = null;
  var returnsLastFocus = null;
  var returnsKeyHandler = null;

  function returnsModalEl() { return document.getElementById('riwi-cart-returns-modal'); }

  function refreshReturnsModal() {
    var fresh = document.querySelector('[data-riwi-cart] [data-rc-returns-modal]');
    if (returnsPortal && returnsPortal.parentNode) {
      /* Dialog haengt schon an <body> -- eine frisch mitgerenderte Kopie im neuen Markup ist
         ein Duplikat (gleiche id="riwi-cart-returns-modal") und wird verworfen. */
      if (fresh) fresh.remove();
      return;
    }
    if (!fresh) return; /* z. B. Drawer-Refresh ohne refund_policy.body -- kein Dialog im Markup. */
    var portal = document.createElement('div');
    portal.className = 'riwi-cart-returns-portal';
    document.body.appendChild(portal);
    portal.appendChild(fresh);
    returnsPortal = portal;
  }

  function closeReturnsModal() {
    var modal = returnsModalEl();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('riwi-cart-returns-lock');
    if (returnsKeyHandler) { document.removeEventListener('keydown', returnsKeyHandler); returnsKeyHandler = null; }
    var toFocus = returnsLastFocus;
    returnsLastFocus = null;
    if (toFocus && typeof toFocus.focus === 'function') toFocus.focus();
  }

  function openReturnsModal(trigger) {
    var modal = returnsModalEl();
    if (!modal) return;
    returnsLastFocus = trigger || document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('riwi-cart-returns-lock');
    var title = modal.querySelector('.riwi-cart__returns-title');
    var panel = modal.querySelector('[data-rc-returns-panel]');
    (title || panel || modal).focus();

    /* Fokusfalle: Tab/Shift+Tab bleibt innerhalb des Dialogs. ESC schliesst. */
    returnsKeyHandler = function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeReturnsModal(); return; }
      if (e.key !== 'Tab') return;
      var focusables = modal.querySelectorAll('button:not([disabled]), [href]');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', returnsKeyHandler);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-rc-returns-open]');
    if (opener) {
      if (!returnsModalEl()) return; /* kein Dialog im Markup (Fallback) -- normale Navigation zur Policy-URL. */
      e.preventDefault();
      openReturnsModal(opener);
      return;
    }
    if (e.target.closest && e.target.closest('[data-rc-returns-close]')) {
      e.preventDefault();
      closeReturnsModal();
    }
  });

  function activate() {
    document.querySelectorAll('[data-riwi-cart].no-js').forEach(function (box) { box.classList.remove('no-js'); });
    document.querySelectorAll('[data-riwi-cart]').forEach(initEdd);
    ensureAddonsScript();
    refreshStickyCheckout();
    refreshReturnsModal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', activate);
  else activate();
  document.addEventListener('riwi-cart:updated', activate);

  window.RiwiCartContents = {
    mutate: mutate, refreshFrom: refreshFrom, isZeroBlocked: isZeroBlocked,
    ensureAddonsScript: ensureAddonsScript, addAndApply: addAndApply, applyCodes: applyCodes,
    mergeCodes: mergeCodes, currentCodes: currentCodes, cartUrl: cartUrl, discountRoute: discountRoute,
    applyCodeFromField: applyCodeFromField
  };
})();
